/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ReactElement } from "react";

import { IMediaCategoryModel, MediaCategoryType } from "@nf/common";
import dynamic from "next/dynamic";

const Layout = dynamic(() => import("layouts/Layout"));

const SearchScreen = dynamic<any>(() =>
  import("screens/SearchScreen").then((mod) => mod.default)
);

import styles from "screens/SearchScreen/SearchScreen.module.scss";

export const getServerSideProps = async (ctx: any) => {
  const { getCommonServerSideProps } = await import(
    "helpers/getCommonServerSideProps"
  );
  const { commonProps, DataProvider } = await getCommonServerSideProps(ctx);

  let genreList: IMediaCategoryModel[] = [];
  const mediaCategories = await DataProvider.getMediaCategories(true);

  if (mediaCategories) {
    genreList = mediaCategories.Entities.filter(
      (item) => item.CategoryTypeCode === MediaCategoryType.Main
    );
  }

  return {
    props: {
      ...commonProps,
      genreList,
      ssrRenderDefaultPanel: true,
    },
  };
};

const SearchScreenWrapper = (props: any) => {
  return <SearchScreen {...props} />;
};

SearchScreenWrapper.getLayout = function getLayout(page: ReactElement) {
  const { props } = page;
  return (
    <Layout config={props?.config} className={styles.layout}>
      {page}
    </Layout>
  );
};

export default SearchScreenWrapper;
